import React from 'react'

import StructuredTextReport from '../../../structured-text-report/structured-text-report'

import ImageDirection from '../../../image-direction'

import * as style from './columns-slide.module.scss'

const ColumnsSlide = ({ slide, customIndex }) => {
  return (
    <>
      <div className="col-12">
        {slide.isContinued ? null : (
          <span className={`tag`}>Insight 0{customIndex}</span>
        )}
        <h3 className={`text-base-000 h300 m-0 ${style.title}`}>
          {slide.title}
        </h3>
      </div>
      {slide?.columns?.length > 0 &&
        slide.columns.map((column, i) => (
          <div
            key={'slide-column-' + i}
            className={`col-12 ${
              slide.columns.length === 1
                ? 'col-lg-12'
                : slide.columns.length === 2
                  ? 'col-lg-6'
                  : slide.columns.length === 4
                    ? 'col-lg-3'
                    : 'col-lg-4'
            }`}
          >
            {column?.content && (
              <StructuredTextReport
                content={column.content}
                className={`${style.columnContent} ${
                  style[`columnContent${i + 1}`]
                }`}
              />
            )}
          </div>
        ))}
      <div className={`${style.imageColumn} col-12`}>
        {slide?.imageDesktop && (
          <ImageDirection
            className={style.image}
            image={slide.imageDesktop}
            imageMobile={slide.imageMobile}
            alt={slide?.imageDesktop?.alt ?? slide?.imageMobile?.alt}
          />
        )}
      </div>
    </>
  )
}

export default ColumnsSlide
